import { cn } from '@/utils/tailwind-util';
import { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { Logo } from '@/assets/svg/logo';
import { MenuList } from '@/navigation/menu';
import { AlarmcenterTrigger } from '@/features/alarmcenter';
import { useFetchUserDetail } from '@/services';
import { UserRoleCodeEnum } from '@/types/enums';
import UserSide from './UserSide';

/**
 * Nav 상단 우측 Menu
 */

const Menu = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const { pathname } = useLocation();
  const rootPath = '/' + pathname.split('/')[1];

  const user = useFetchUserDetail();
  const isSuperAdmin = user?.userRoleCode === UserRoleCodeEnum['총괄 매니저'];
  const isSystemAdmin = user?.userRoleCode === UserRoleCodeEnum['시스템 관리자'];

  // 권한에 따라 메뉴 필터링
  const filteredMenuList = useMemo(() => {
    return MenuList.filter((item) => {
      // 최상위 메뉴 권한 체크
      if (item.systemAdminOnly && !isSystemAdmin) return false;
      if (item.superAdminOnly && !isSuperAdmin) return false;
      return true;
    }).map((item) => {
      if (!item.children) return item;

      const filteredChildren = item.children.filter((child) => {
        if (child.systemAdminOnly && !isSystemAdmin) return false;
        if (child.superAdminOnly && !isSuperAdmin) return false;
        return true;
      });

      return { ...item, children: filteredChildren };
    });
  }, [isSuperAdmin, isSystemAdmin]);


  const handleMouseEnter = (menu) => {
    setHoveredMenu(menu);
  };
  const handleMouseLeave = () => {
    setHoveredMenu(null);
  };

  return (
    <div className="flex flex-row justify-between w-full items-stretch px-4 lg:px-9 h-nav-h border-b-gray-300 border-b">
      <NavLink className="h-nav-h flex items-center" to="/task">
        <Logo />
      </NavLink>
      <div className="flex items-end">
        <ul className="flex gap-5 lg:gap-10">
          {filteredMenuList.map((item) => (
            <li
              className={cn(
                'min-w-20 hover:text-primary border-b-2 border-transparent hover:border-primary pb-0.5 relative',
                rootPath === item.path && 'border-primary',
                hoveredMenu === item.name && 'border-none'
              )}
              key={item.path}
              onMouseEnter={() => handleMouseEnter(item.name)}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink
                className={cn(
                  'block h-8 text-base font-medium text-center text-gray-500 hover:text-primary',
                  rootPath === item.path && 'text-primary'
                )}
                to={item.children ? item.children[0].path : item.path}
              >
                {item.name}
              </NavLink>
              {item.dropdown && hoveredMenu === item.name && (
                <div className="absolute top-full bg-white shadow-lg rounded-md z-[100000]">
                  <ul className="flex flex-col">
                    {item.children.map((child) => (
                      <li key={child.path}>
                        <NavLink
                          className={cn(
                            'block p-4 text-center text-sm text-gray-700 hover:bg-gray-100 whitespace-nowrap cursor-pointer',
                            rootPath === child.path && 'bg-gray-200'
                          )}
                          to={child.path}
                        >
                          {child.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex items-center gap-2">
        <AlarmcenterTrigger />
        <UserSide />
      </div>
    </div>
  );
};

export default Menu;
